import {createPathToAction} from "./create_path_to_action";
import {PATH_TO_ACTION_MAP} from "./path_to_action_map";

export const chartsPathToAction = createPathToAction(PATH_TO_ACTION_MAP);
